import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "axios";

const DeleteBox = ({
  showModal,
  onClose,
  deleteID,
  endPoint,
  entityLabel,
  title = "Confirm Deletion",
  cancelLabel = "Cancel",
  applyLabel = "Delete",
  onResponse
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleApply = async () => {
    try {
      setIsLoading(true);
      const url = `${process.env.REACT_APP_NODE_URL}/api/${endPoint}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };
      const response = await axios.post(url, { deleteID }, config);
      if (response && response.data.success) {
        await onResponse(response.data)
        onClose();
      }
    } catch (error) {
      console.error("Error while deleting:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <h5 className="p-0 m-0 w-100 text-primary">
          {title} - <span className="text-dark">{entityLabel}</span>
        </h5>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center mb-4 text-muted">
          Are you sure you want to proceed with this action? This action cannot
          be undone.
        </p>
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-outline-secondary rounded-pill px-4 py-2 me-3"
            onClick={onClose}
            disabled={isLoading}
            aria-label="Cancel Deletion"
          >
            {cancelLabel}
          </button>
          <button
            className="btn btn-danger text-white rounded-pill px-4 py-2 d-flex align-items-center justify-content-center"
            onClick={handleApply}
            disabled={isLoading}
            aria-label="Confirm Deletion"
          >
            {isLoading && (
              <Spinner animation="border" size="sm" className="me-2" />
            )}
            {isLoading ? "Deleting..." : applyLabel}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteBox;
